/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowServiceCatalogCategory {
    getFixupPrototypeFunction() { return ServiceNowServiceCatalogCategory.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowServiceCatalogCategory>): ServiceNowServiceCatalogCategory {
        let obj = Object.assign(new ServiceNowServiceCatalogCategory(), model);
        ServiceNowServiceCatalogCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowServiceCatalogCategory>): ServiceNowServiceCatalogCategory {
        if (!model) return null;
        return ServiceNowServiceCatalogCategory.newInstance(<ServiceNowServiceCatalogCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowServiceCatalogCategory) {
        if (!obj) return;

        models.ServiceNowServiceCatalogCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowServiceCatalogCategory): boolean {
        Object.setPrototypeOf(obj, ServiceNowServiceCatalogCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.category) {
            models.ServiceNowRequestComponent.fixupPrototype(this.category);
        }
        if (this.sub_categories) {
            for (let val of this.sub_categories) {
                models.ServiceNowServiceCatalogSubCategory.fixupPrototype(val);
            }
        }
    }

    category: models.ServiceNowRequestComponent;

    /**
     * List of Service Catalog SubCategories
     */
    sub_categories: Array<models.ServiceNowServiceCatalogSubCategory>;

}
